// logged-in.providers.ts
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { RestaurantGroupStore } from '#modules/restaurant-groups/views/restaurant-groups-view/stores/restaurant-group.store';
import { AggregatedGmbInsightsContext } from '#modules/statistics-seo/contexts/aggregated-seo/aggregated-gmb-insights.context';
import { AggregatedStatisticsFiltersContext } from '#modules/statistics/components/aggregated-statistics-filters/aggregated-statistics-filters.context';
import { DownloadAggregatedCsvInsightsService } from '#modules/statistics/components/download-insights-modal/services/download-aggregated-csv-insights.service';
import { AbstractDownloadCsvInsights } from '#modules/statistics/components/download-insights-modal/services/download-csv-insights.abstract.service';
import { DOWNLOAD_AGGREGATED_CSV_INSIGHTS_PROVIDERS } from '#modules/statistics/components/download-insights-modal/utils/providers/download-aggregated-csv-insights.provider';
import { AggregatedStatisticsStore } from '#modules/statistics/stores/aggregated-store/aggregated-statistics.store';
import { AggregatedStatisticsHttpErrorPipe } from '#modules/statistics/utils/pipes/aggregated-statistics-http-error.pipe';
import { DOWNLOAD_AGGREGATED_INSIGHTS_SUMMARY_PROVIDERS } from '#modules/statistics/utils/providers/csv-inisights-summary/download-aggregated-insights-summary';

export function provideAggregatedStatisticsScope(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: AbstractDownloadCsvInsights, useClass: DownloadAggregatedCsvInsightsService },
        AggregatedGmbInsightsContext,
        AggregatedStatisticsHttpErrorPipe,
        AggregatedStatisticsStore,
        AggregatedStatisticsFiltersContext,
        RestaurantGroupStore,
        ...DOWNLOAD_AGGREGATED_INSIGHTS_SUMMARY_PROVIDERS,
        ...DOWNLOAD_AGGREGATED_CSV_INSIGHTS_PROVIDERS,
    ]);
}
